module.exports = __webpack_public_path__ + "be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/be.svg
// module id = 441
// module chunks = 0